import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';

export default {
  name: 'Currency',
  components: {
    DatePicker,
  },
  props: {},
  data() {
    return {
      date: new Date(),
    };
  },
  computed: {
    getCurrency() {
      return this.$store.getters['docs/getterCurrency'];
    },
    getChar() {
     return this.$i18n.t('currency.char');
    },
    getCourse() {
      return this.$i18n.t('currency.course');
    },
  },
  created() {
    this.fetchCurrency();
  },
  watch: {
    date() {
      this.fetchCurrency();
    },
  },
  mounted() {

  },
  methods: {
    fetchCurrency() {
      this.$store.dispatch('docs/fetchCurrency', { date: this.date });
    },
    isDateDisabled(date) {
      const today = new Date();
      return date > today;
    },
  },
};
